import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Location } from '@angular/common';
import { Breadcrumb } from 'src/app/shared/domain/breadcrumb.entity';
import { IState } from 'src/app/shared/store/root.reducer';

@Component({
  selector: 'app-header-breadcrumb',
  templateUrl: './header-breadcrumb.component.html',
  styleUrls: ['./header-breadcrumb.component.scss']
})
export class HeaderBreadcrumbComponent implements OnInit, OnDestroy {
  @Input() breadcrumb: Breadcrumb;
  @Input() supplierName: string;
  printSubscription: Subscription;
  breadcrumbTitleCssClass: string;

  constructor(
    private store: Store<IState>,
    private location: Location
  ) { }

  ngOnInit() {
    this.printSubscription = this.store.pipe(select(state => state.print))
      .subscribe(printState => {
        this.breadcrumbTitleCssClass = printState.breadcrumbTitleCssClass;
      });
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    if (this.printSubscription) {
       this.printSubscription.unsubscribe();
    }
  }
}
